(function () {
/**
 * @function shuffle
 * @description Shuffle the deck
 * @url https://vanillajstoolkit.com/helpers/shuffle/
 * @param {Array} array the array to be shuffled
 */ function $a4aeb41909f85d83$export$2e2bcd8739ae039(array) {
    var currentIndex = array.length, temporaryValue, randomIndex;
    while(0 !== currentIndex){
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
    }
    return array;
}


function $c03bd83856b37a95$export$2e2bcd8739ae039(deck, total, random) {
    if (random) deck = (0, $a4aeb41909f85d83$export$2e2bcd8739ae039)(deck);
    return deck.slice(0, total);
}


/**
 * @function createTag
 * @description create an HTML element with an attribute and styles
 * @param {string} tag HTML tag of the element
 * @param {string} attr attribute to add to the HTML tag
 * @param {string} value the value of the attribute
 * @param {string} style the style string to apply to the element
 * @returns {HTMLElement}
 */ function $11e2c71ebea68895$export$2e2bcd8739ae039(tag, attr, value, style) {
    /* simplify the creation of tags with data-attributes */ var element = document.createElement(tag);
    if (attr) element.setAttribute(attr, value);
    if (style) element.setAttribute("class", style);
    return element;
}


function $67ba6e2ee39d3fab$export$2996f80ef42b8419(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $478d113bc998a91d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $478d113bc998a91d$export$d60067ff2358eee8(Constructor, protoProps, staticProps) {
    if (protoProps) $478d113bc998a91d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $478d113bc998a91d$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $e143ab5c23731491$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


var $1d310609a408d7ab$var$Modal = /*#__PURE__*/ function() {
    "use strict";
    function Modal() {
        (0, $67ba6e2ee39d3fab$export$2996f80ef42b8419)(this, Modal);
        (0, $e143ab5c23731491$export$1e71eb4bef00f6b0)(this, "conf", void 0);
        this.conf = {};
        this.create();
    }
    (0, $478d113bc998a91d$export$d60067ff2358eee8)(Modal, [
        {
            key: "create",
            value: function create() {
                var _this = this;
                window.MaestroInstance.Store.loadAsync("tarot-config").then(function(e) {
                    _this.conf = e;
                    var elment = document.querySelector("#app-emi-tarot");
                    var modal = document.createElement("div");
                    modal.className = "modal";
                    var modalContent = document.createElement("div");
                    modalContent.className = "modal-content";
                    var closeContainer = document.createElement("div");
                    closeContainer.className = "close-container";
                    var closeBtn = document.createElement("button");
                    var textContainer = document.createElement("div");
                    var text = document.createElement("div");
                    textContainer.style = "margin: 10px;";
                    textContainer.appendChild(text);
                    var _e_textModal;
                    text.innerText = (_e_textModal = e.textModal) !== null && _e_textModal !== void 0 ? _e_textModal : "Your card";
                    closeBtn.className = "close-btn-modal";
                    var _e_btnTextModal;
                    closeBtn.innerText = (_e_btnTextModal = e.btnTextModal) !== null && _e_btnTextModal !== void 0 ? _e_btnTextModal : "Sign up";
                    closeBtn.onclick = _this.close;
                    closeContainer.appendChild(textContainer);
                    closeContainer.appendChild(closeBtn);
                    modal.appendChild(modalContent);
                    modalContent.appendChild(closeContainer);
                    elment.appendChild(modal);
                    modal.style.display = "none";
                });
            }
        },
        {
            key: "open",
            value: function open(cb) {
                var isMobile = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                var modal = document.querySelector(".modal");
                var modalContent = document.querySelector(".modal-content");
                if (isMobile) modalContent.style = "height:45%; width: 100%";
                var cardsSelected = !isMobile ? document.querySelectorAll(".tarot-scene--selected") : document.querySelectorAll('article[card-selected="true"]');
                var cardsContainer = document.createElement("div");
                cardsContainer.className = "cards-container";
                if (isMobile) cardsContainer.style = "min-height: 180px; padding-top: 0;";
                var closeContainer = document.querySelector(".close-container");
                var btn = document.querySelector(".close-btn-modal");
                btn.onclick = function() {
                    cb();
                    _this.close();
                };
                modalContent.insertBefore(cardsContainer, closeContainer);
                cardsSelected.forEach(function(item) {
                    if (isMobile) {
                        var index = parseInt(item.getAttribute("data-emi-carousel-index"));
                        item.style.transform = "none";
                        item.removeAttribute("data-emi-carousel-index");
                        item.style.opacity = 1;
                        item.classList.remove("carousel-card-selected");
                        item.style.content = "none";
                        item.removeAttribute("id");
                        item.classList.remove("app-emi-carousel-card");
                        item.style.height = "100%";
                        item.style.width = "100%";
                        item.style.backgroundImage = "url(".concat(_this.conf.originalDeck[index].source, ")");
                    }
                    item.onclick = null;
                    cardsContainer.onclick = null;
                    cardsContainer.appendChild(item);
                });
                modal.style.display = "flex";
                setTimeout(function() {
                    modalContent.classList.add("modal-open");
                }, 100);
            }
        },
        {
            key: "close",
            value: function close() {
                var elment = document.querySelector("#app-emi-tarot");
                var modal = document.querySelector(".modal");
                modal.style.display = "none";
                elment.removeChild(modal);
            }
        },
        {
            key: "recreate",
            value: function recreate() {
                this.create();
            }
        }
    ]);
    return Modal;
}();
var $1d310609a408d7ab$export$96e4b36520c26a2c = new $1d310609a408d7ab$var$Modal();


function $28de813c3c060390$export$2e2bcd8739ae039(data, element, i, duration) {
    var module = data.config.module;
    if (data.state.disabled) return;
    // trigger the event only once for the same element
    var card = document.querySelector("[data-emi-".concat(module, '-scene="').concat(i, '"]'));
    if (card.classList.contains("".concat(module, "-scene--reveal"))) return;
    if (!data.config.modalReveal) card.classList.add("".concat(module, "-scene--reveal"));
    else card.classList.add("".concat(module, "-scene--selected"));
    if (data.config.pile) {
        card.style.transform = "translateY(0px) translateX(calc(60% * ".concat(data.state.selected.length, "))");
        card.style.zIndex = "".concat(data.state.selected.length);
    }
    if (data.config.rotation) document.querySelector("[data-emi-".concat(module, "-back")).style.transform = "rotate(".concat(data.config.rotation, ")");
    data.state.selected.push(i);
    // disable the event until animation ends
    data.stop();
    console.log("animation start");
    setTimeout(function() {
        data.start();
        if (data.state.selected.length === data.config.amount) {
            data.stop();
            if (data.config.modalReveal) {
                var cb = function() {
                    return Maestro.getInstance().EventBus.emit("".concat(module, "-card-selected"), data.result());
                };
                (0, $1d310609a408d7ab$export$96e4b36520c26a2c).open(cb);
            } else {
                document.querySelector("[data-emi-".concat(module, "-table]")).classList.add("status--disabled");
                document.getElementById("app-emi-".concat(module)).classList.add("status--disabled");
                Maestro.getInstance().EventBus.emit("".concat(module, "-card-selected"), data.result());
            }
        }
        if (data.state.selected.length !== data.config.amount) {
            if (data.config.hideBetweenStep) setTimeout(function() {
                Maestro.getInstance().EventBus.emit("".concat(module, "-card-selected"), data.result());
            }, 800);
            else Maestro.getInstance().EventBus.emit("".concat(module, "-card-selected"), data.result());
        }
        console.log("animation end");
    }, duration);
}


/**
 * @function idle
 * @description create the idle state for the tarot
 * @param {HTMLElement} element
 * @returns
 */ function $3ef60bf81ca71e42$export$2e2bcd8739ae039(element) {
    /* adds the idle animation */ element.classList.add("promote");
    window.setTimeout(function() {
        element.classList.remove("promote");
    }, 250);
    return;
}


function $45e5c0a19c79096c$export$2e2bcd8739ae039(data) {
    var module = data.config.module;
    var id = document.getElementById("app-emi-".concat(module));
    // check if the module was already rendered, if so, empty the container element
    var destroy = document.querySelector("[data-emi-".concat(module, "-table]"));
    if (destroy) id.innerHTML = "";
    /* ul.table */ var ul = (0, $11e2c71ebea68895$export$2e2bcd8739ae039)("ul", "data-emi-".concat(module, "-table"), "", Object.keys(data.config.css).filter(function(key) {
        return data.config.css[key];
    }).join(" "));
    ul.setAttribute("data-emi-module", data.config.module || "no-module");
    ul.setAttribute("data-emi-".concat(module, "-shape"), data.config.shape || "no-shape");
    ul.setAttribute("data-emi-".concat(module, "-speed"), data.config.speed || "no-speed");
    ul.style.position = "relative";
    id.prepend(ul);
    /* h2.title */ if (data.title.start) {
        var titleStart = (0, $11e2c71ebea68895$export$2e2bcd8739ae039)("h2", "data-emi-".concat(module, "-title"), "start");
        titleStart.innerHTML = data.title.start;
        id.prepend(titleStart);
    }
    if (data.title.end) {
        var titleEnd = (0, $11e2c71ebea68895$export$2e2bcd8739ae039)("h2", "data-emi-".concat(module, "-title"), "end");
        titleEnd.innerHTML = data.title.end;
        id.prepend(titleEnd);
    }
    var fragment = document.createDocumentFragment();
    // create the tarot deck
    data.deck.forEach(function(item, index) {
        /* li.scene */ var li = (0, $11e2c71ebea68895$export$2e2bcd8739ae039)("li", "data-emi-".concat(module, "-scene"), index);
        fragment.appendChild(li);
        if (data.config.pile) li.style.transform = "\n                translateY(".concat(data.config.pile[index][0] + 75, "px)\n                translateX(calc(20% + ").concat(data.config.pile[index][1] - 50, "px))\n                rotate(").concat(index * Math.floor(Math.random() * 50) + 1, "deg)\n            ");
        /* a.item */ var a = (0, $11e2c71ebea68895$export$2e2bcd8739ae039)("a", "data-emi-".concat(module, "-item"), "");
        a.setAttribute("href", "#");
        a.setAttribute("role", "button");
        a.onclick = function(e) {
            e.preventDefault();
            (0, $28de813c3c060390$export$2e2bcd8739ae039)(data, this, index, data.config.duration);
        };
        li.appendChild(a);
        // trigger idle animation
        if (data.config.animation) {
            window.setTimeout(function() {
                (0, $3ef60bf81ca71e42$export$2e2bcd8739ae039)(li);
            }, index * 100);
            window.setInterval(function() {
                window.setTimeout(function() {
                    (0, $3ef60bf81ca71e42$export$2e2bcd8739ae039)(li);
                }, index * 100);
            }, 100 * (data.deck.length + 2));
        }
        /* img */ var imgFront = (0, $11e2c71ebea68895$export$2e2bcd8739ae039)("img", "data-emi-".concat(module, "-front"), "");
        imgFront.setAttribute("src", item.source), a.appendChild(imgFront);
        /* img.frame */ if (data.frame) {
            var frame = (0, $11e2c71ebea68895$export$2e2bcd8739ae039)("img", "data-emi-".concat(module, "-frame"), "");
            frame.setAttribute("src", data.frame.source);
            a.appendChild(frame);
        }
        var imgBack = (0, $11e2c71ebea68895$export$2e2bcd8739ae039)("img", "data-emi-".concat(module, "-back"), "");
        imgBack.setAttribute("src", data.back.source), a.appendChild(imgBack);
        var imgPlaceholder = (0, $11e2c71ebea68895$export$2e2bcd8739ae039)("img", "data-emi-".concat(module, "-placeholder"), "");
        imgPlaceholder.setAttribute("src", data.back.source), li.appendChild(imgPlaceholder);
    });
    ul.appendChild(fragment);
    var scrollbar = document.createElement("div");
    scrollbar.id = "scrollbar";
    var scI = document.createElement("span");
    scI.id = "scrollbarItem";
    ul.appendChild(scrollbar);
    var ua = navigator.userAgent.toLowerCase();
    var isAndroid = ua.indexOf("android") > -1; //&& ua.indexOf("mobile");
    if (isAndroid) scI.style.display = "none";
    scrollbar.appendChild(scI);
    // Listen to Maestro by subscribing to the event bus
    Maestro.getInstance().Store.save("".concat(module, "-status"), {
        initialized: true
    });
    Maestro.getInstance().EventBus.on("".concat(module, "-stop"), function() {
        // Stop the module
        data.stop();
        data.log();
        id.classList.add("status--disabled");
    }).on("".concat(module, "-start"), function(e) {
        // Restart the module
        data.start();
        data.log();
        id.classList.remove("status--disabled");
    });
    console.timeEnd("render_time");
}


/**
 * @function jitter
 * @description Shake the deck (disposition)
 * @param {number} m
 * @param {number} n
 * @returns
 */ function $aac1ceba87c6510c$export$2e2bcd8739ae039(m, n) {
    var output = [];
    var maze_size = m * n * 3;
    for(var i = 1; i < m; i++)for(var j = 1; j < n; j++)output.push([
        i * maze_size + Math.floor(Math.random() * (maze_size / 2)),
        j * maze_size + Math.floor(Math.random() * (maze_size / 2))
    ]);
    return output;
}


/**
 * @version 0.0.1
 * @description Create and manage the loader inside the document
 * @example
 * import Loader from 'loader.js';
 * Loader.create();
 */ 

var $ae4f30d3c59c8ad6$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function Loader() {
        (0, $67ba6e2ee39d3fab$export$2996f80ef42b8419)(this, Loader);
    }
    (0, $478d113bc998a91d$export$d60067ff2358eee8)(Loader, null, [
        {
            key: "create",
            value: /**
     * @static create
     * @description Create the loader inside the existing loader div
     */ function create() {
                var loaderHTMLElement = Loader.selectLoaderHTMLElement();
                if (loaderHTMLElement !== null) Loader.tarotLoader(loaderHTMLElement);
            }
        },
        {
            key: "hide",
            value: /**
     * @static hide
     * @description hide the loader by setting the display to none
     */ function hide() {
                var loaderAttrString = "[data-emi-tarot-loader]";
                var loaderHTMLElement = document.querySelector(loaderAttrString);
                if (loaderHTMLElement !== null) loaderHTMLElement.style.display = "none";
            }
        },
        {
            key: "selectLoaderHTMLElement",
            value: /**
     * @static selectLoaderHTMLElement
     * @description select the html element identified by the argument data-emi-rune-loader
     * @return {HTMLElement | null}
     */ function selectLoaderHTMLElement() {
                var loaderAttrString = "[data-emi-tarot-loader]";
                var elt = document.querySelector(loaderAttrString);
                // if a loader element is already in the page use it
                if (elt) {
                    var div = document.createElement("div");
                    div.classList.add("loader");
                    elt.appendChild(div);
                    return document.querySelector("[data-emi-tarot-loader] div");
                } else {
                    var loader = document.createElement("div");
                    var attr = document.createAttribute("data-emi-tarot-loader");
                    attr.value = "";
                    loader.setAttributeNode(attr);
                    document.body.appendChild(loader);
                    var div1 = document.createElement("div");
                    div1.classList.add("loader");
                    loader.appendChild(div1);
                    return document.querySelector("[data-emi-tarot-loader] div");
                }
            }
        },
        {
            key: "noMaestroError",
            value: /**
     * @static
     * @description display the error message for the case where the HTML element for the loader is not found
     */ function noMaestroError() {
                var msgTitle = "Woops!!";
                var msgText = "<strong>There was a trouble loading your tarot deck!</strong><br/><br/>Please try to reload the page to get a new tarot deck";
                var loader = document.querySelector("[data-emi-tarot-loader]");
                loader.innerHTML = '<div style="position:absolute;left:50%;top:50%;transform:translate(-50%,-50%)"><h1>'.concat(msgTitle, "</h1><p>").concat(msgText, "</p></div>");
            }
        },
        {
            key: "tarotLoader",
            value: /**
     * @static tarotLoader
     * @description create and inject inside htmlElement the loader
     * @param {HTMLElement} htmlElement the HTML Element in which to inject the loader
     */ function tarotLoader(htmlElement) {
                for(var i = 7; i > 0; i--){
                    var elt = document.createElement("div");
                    elt.id = "l0" + i;
                    var span = document.createElement("span");
                    span.className = "lds-cd-bd";
                    elt.appendChild(span);
                    htmlElement.appendChild(elt);
                }
            }
        }
    ]);
    return Loader;
}();





var $adcbf0c91fbb7cf7$export$a002182e51710d39 = {
    MAIN: "#app-emi-tarot-carousel-main",
    LEFT_ARROW: "#app-emi-carousel-left-arrow",
    RIGHT_ARROW: "#app-emi-carousel-right-arrow",
    CARD_LIST: "#app-emi-carousel-cardlist",
    POSITION_ATTRIBUTE: "data-emi-carousel-position",
    CARDS: ".app-emi-carousel-card",
    MOBILE_MEDIA: "only screen and (max-width: 768px)",
    CLICK_EVENT: "click"
};
var $adcbf0c91fbb7cf7$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function Carousel() {
        (0, $67ba6e2ee39d3fab$export$2996f80ef42b8419)(this, Carousel);
    }
    (0, $478d113bc998a91d$export$d60067ff2358eee8)(Carousel, null, [
        {
            key: "isMobile",
            value: /**
     * Check if current media is mobile or not
     * @returns boolean
     */ function isMobile() {
                return window.matchMedia($adcbf0c91fbb7cf7$export$a002182e51710d39.MOBILE_MEDIA).matches;
            }
        },
        {
            key: "render",
            value: function render(configuration) {
                Carousel.createScene(configuration);
                (0, $1d310609a408d7ab$export$96e4b36520c26a2c).recreate();
                Carousel.render3D();
                Carousel.addArrowsEventListeners();
                Carousel.addCardsEventListeners(configuration);
                Carousel.addTouchListeners();
                // Listen to Maestro by subscribing to the event bus
                Maestro.getInstance().Store.save("tarot-status", {
                    initialized: true
                });
                Maestro.getInstance().EventBus.on("tarot-stop", function() {
                    // Stop the module
                    configuration.stop();
                    configuration.log();
                    var cardList = document.querySelector($adcbf0c91fbb7cf7$export$a002182e51710d39.MAIN);
                    cardList.setAttribute("tarot-disabled", true);
                    document.querySelector("#title-start").classList.add("app-emi-none");
                    document.querySelector("#title-result").classList.remove("app-emi-none");
                }).on("tarot-start", function(e) {
                    // Restart the module
                    configuration.start();
                    configuration.log();
                    var cardList = document.querySelector($adcbf0c91fbb7cf7$export$a002182e51710d39.MAIN);
                    cardList.setAttribute("tarot-disabled", false);
                    document.querySelector("#title-start").classList.remove("app-emi-none");
                    document.querySelector("#title-result").classList.add("app-emi-none");
                });
            }
        },
        {
            key: "addCardsEventListeners",
            value: function addCardsEventListeners(cardDeck) {
                var cards = document.querySelectorAll($adcbf0c91fbb7cf7$export$a002182e51710d39.CARDS);
                cards.forEach(function(card) {
                    card.addEventListener($adcbf0c91fbb7cf7$export$a002182e51710d39.CLICK_EVENT, function(event) {
                        Carousel.onCardClick(event, cardDeck);
                    });
                });
            }
        },
        {
            key: "removeCardsEventListeners",
            value: function removeCardsEventListeners(cardDeck) {
                var cards = document.querySelectorAll($adcbf0c91fbb7cf7$export$a002182e51710d39.CARDS);
                cards.forEach(function(card) {
                    card.removeEventListener($adcbf0c91fbb7cf7$export$a002182e51710d39.CLICK_EVENT, function(event) {
                        Carousel.onCardClick(event, cardDeck);
                    });
                });
            }
        },
        {
            key: "isCardSelected",
            value: function isCardSelected(card) {
                return card.classList.contains("carousel-card-selected");
            }
        },
        {
            key: "unselectCard",
            value: function unselectCard(card) {
                card.classList.remove("carousel-card-selected");
            }
        },
        {
            key: "onCardClick",
            value: function onCardClick(event, configuration) {
                var cardList = document.querySelector($adcbf0c91fbb7cf7$export$a002182e51710d39.MAIN);
                var position = parseInt(document.querySelector($adcbf0c91fbb7cf7$export$a002182e51710d39.CARD_LIST).getAttribute($adcbf0c91fbb7cf7$export$a002182e51710d39.POSITION_ATTRIBUTE));
                var index = parseInt(event.target.getAttribute("data-emi-carousel-index"));
                if (index === position && !event.target.getAttribute("card-selected")) {
                    // Reveal Card
                    if (configuration.state.selected.length < configuration.config.amount) {
                        if (cardList.getAttribute("tarot-disabled") !== "true") {
                            event.target.classList.add("carousel-card-selected");
                            event.target.setAttribute("card-selected", true);
                            if (!configuration.config.modalReveal) event.target.style.transform = event.target.style.transform.concat(" rotateY(180deg)");
                            if (!configuration.config.modalReveal) setTimeout(function() {
                                event.target.style.backgroundImage = "url(".concat(configuration.deck[index].source, ")");
                            }, 150);
                            configuration.state.selected.push(index);
                        }
                    } else {
                        configuration.stop();
                        document.querySelector($adcbf0c91fbb7cf7$export$a002182e51710d39.CARD_LIST).classList.add("status--disabled");
                        document.getElementById("app-emi-tarot").classList.add("status--disabled");
                    }
                    if (configuration.state.selected.length === configuration.config.amount && configuration.config.modalReveal) {
                        var cb = function() {
                            return Maestro.getInstance().EventBus.emit("tarot-card-selected", configuration.result());
                        };
                        (0, $1d310609a408d7ab$export$96e4b36520c26a2c).open(cb, true);
                        Carousel.removeCardsEventListeners(configuration);
                    } else Maestro.getInstance().EventBus.emit("tarot-card-selected", configuration.result());
                } else if (cardList.getAttribute("tarot-disabled") !== "true") {
                    if (index > position) {
                        // Move Carousel
                        Carousel.onRightArrowClick();
                        var cards = document.querySelectorAll($adcbf0c91fbb7cf7$export$a002182e51710d39.CARDS);
                        cards.forEach(function(card) {
                            Carousel.unselectCard(card);
                        });
                    } else {
                        // Move Carousel
                        Carousel.onLeftArrowClick();
                        var cards1 = document.querySelectorAll($adcbf0c91fbb7cf7$export$a002182e51710d39.CARDS);
                        cards1.forEach(function(card) {
                            Carousel.unselectCard(card);
                        });
                    }
                }
            }
        },
        {
            key: "addArrowsEventListeners",
            value: function addArrowsEventListeners() {
                var arrL = document.querySelector($adcbf0c91fbb7cf7$export$a002182e51710d39.LEFT_ARROW);
                arrL.addEventListener($adcbf0c91fbb7cf7$export$a002182e51710d39.CLICK_EVENT, function() {
                    Carousel.onLeftArrowClick();
                    var cards = document.querySelectorAll($adcbf0c91fbb7cf7$export$a002182e51710d39.CARDS);
                    cards.forEach(function(card) {
                        Carousel.unselectCard(card);
                    });
                });
                var arrR = document.querySelector($adcbf0c91fbb7cf7$export$a002182e51710d39.RIGHT_ARROW);
                arrR.addEventListener($adcbf0c91fbb7cf7$export$a002182e51710d39.CLICK_EVENT, function() {
                    Carousel.onRightArrowClick();
                    var cards = document.querySelectorAll($adcbf0c91fbb7cf7$export$a002182e51710d39.CARDS);
                    cards.forEach(function(card) {
                        Carousel.unselectCard(card);
                    });
                });
            }
        },
        {
            key: "calculateLeftPosition",
            value: function calculateLeftPosition(currentPosition) {
                return currentPosition - 1 > 0 ? currentPosition - 1 : 0;
            }
        },
        {
            key: "calculateRightPosition",
            value: function calculateRightPosition(currentPosition, cardElements) {
                return currentPosition < cardElements.length - 1 ? Number(currentPosition) + 1 : cardElements.length - 1;
            }
        },
        {
            key: "onLeftArrowClick",
            value: function onLeftArrowClick() {
                var elt = document.querySelector($adcbf0c91fbb7cf7$export$a002182e51710d39.CARD_LIST);
                var position = elt.getAttribute($adcbf0c91fbb7cf7$export$a002182e51710d39.POSITION_ATTRIBUTE);
                elt.setAttribute($adcbf0c91fbb7cf7$export$a002182e51710d39.POSITION_ATTRIBUTE, Carousel.calculateLeftPosition(Number(position)));
                Carousel.render3D();
            }
        },
        {
            key: "onRightArrowClick",
            value: function onRightArrowClick() {
                var elt = document.querySelector($adcbf0c91fbb7cf7$export$a002182e51710d39.CARD_LIST);
                var position = elt.getAttribute($adcbf0c91fbb7cf7$export$a002182e51710d39.POSITION_ATTRIBUTE);
                var cardElements = document.querySelectorAll($adcbf0c91fbb7cf7$export$a002182e51710d39.CARDS);
                elt.setAttribute($adcbf0c91fbb7cf7$export$a002182e51710d39.POSITION_ATTRIBUTE, Carousel.calculateRightPosition(Number(position), cardElements));
                Carousel.render3D();
            }
        },
        {
            key: "createScene",
            value: function createScene(configuration) {
                //identifies the widget html element
                var widgetHtmlElement = document.querySelector("#app-emi-tarot");
                //empty the html of the widget element - in case of already rendered widget tarot
                widgetHtmlElement.innerHTML = "";
                //create title space
                //create the fragment - fragment have better performance than direct html element
                var sceneFragment = document.createDocumentFragment();
                var titleParams = {
                    start: configuration.title.start,
                    result: configuration.title.end
                };
                sceneFragment.appendChild(Carousel.createTitle(titleParams));
                sceneFragment.appendChild(Carousel.createCarousel(configuration));
                var tirageHtmlElement = document.createElement("section");
                tirageHtmlElement.id = "app-emi-tarot-carousel-draws";
                sceneFragment.appendChild(tirageHtmlElement);
                widgetHtmlElement.appendChild(sceneFragment);
            }
        },
        {
            key: "createTitle",
            value: function createTitle(titleParams) {
                var titleHtmlElement = document.createElement("section");
                titleHtmlElement.id = "app-emi-tarot-carousel-title";
                titleHtmlElement.appendChild(Carousel.createElement({
                    tag: "h2",
                    html: titleParams.start,
                    id: "title-start"
                }));
                titleHtmlElement.appendChild(Carousel.createElement({
                    tag: "h2",
                    html: titleParams.result,
                    id: "title-result",
                    classes: [
                        "app-emi-none"
                    ]
                }));
                return titleHtmlElement;
            }
        },
        {
            key: "createElement",
            value: function createElement(parameters) {
                var elt = document.createElement(parameters.tag);
                if (parameters.id) elt.id = parameters.id;
                if (parameters.html) elt.innerHTML = parameters.html;
                if (parameters.classes && parameters.classes.length) for(var i = 0; i < parameters.classes.length; i++)elt.classList.add(parameters.classes[i]);
                if (parameters.attributes && parameters.attributes.length) for(var i1 = 0; i1 < parameters.attributes.length; i1++)elt.setAttribute(parameters.attributes[i1].key, parameters.attributes[i1].value);
                if (parameters.style) elt.style = parameters.style;
                return elt;
            }
        },
        {
            key: "createCarousel",
            value: function createCarousel(configuration) {
                var carouselHtmlElement = Carousel.createElement({
                    tag: "section",
                    id: "app-emi-tarot-carousel-main"
                });
                var leftArrowContainer = Carousel.createElement({
                    tag: "div",
                    id: "app-emi-carousel-left-arrow",
                    html: '<svg style="width:100%;height:48px" viewBox="0 0 24 24"><path fill="currentColor" d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z" /></svg>'
                });
                carouselHtmlElement.appendChild(leftArrowContainer);
                var cardListContainer = Carousel.createElement({
                    tag: "div",
                    id: "app-emi-carousel-cardlist",
                    attributes: [
                        {
                            key: "data-emi-carousel-position",
                            value: Math.ceil(configuration.deck.length / 2) - 1
                        }
                    ]
                });
                for(var i = 0; i < configuration.deck.length; i++){
                    var cardContainer = Carousel.createElement({
                        tag: "article",
                        id: "card-".concat(i.toString()),
                        classes: [
                            "app-emi-carousel-card"
                        ],
                        attributes: [
                            {
                                key: "data-emi-carousel-index",
                                value: i
                            }
                        ],
                        style: "background-image: url(".concat(configuration.back.source, "); background-size: contain; background-position: center; background-repeat: no-repeat")
                    });
                    cardListContainer.appendChild(cardContainer);
                }
                carouselHtmlElement.appendChild(cardListContainer);
                var rightArrowContainer = Carousel.createElement({
                    tag: "div",
                    id: "app-emi-carousel-right-arrow",
                    html: '<svg style="width:100%;height:48px" viewBox="0 0 24 24"><path fill="currentColor" d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" /></svg>'
                });
                carouselHtmlElement.appendChild(rightArrowContainer);
                return carouselHtmlElement;
            }
        },
        {
            key: "addTouchListeners",
            value: function addTouchListeners() {
                var cardListContainer = document.querySelector($adcbf0c91fbb7cf7$export$a002182e51710d39.CARD_LIST);
                var touchstartX = 0;
                var touchendX = 0;
                cardListContainer.addEventListener("touchstart", function(event) {
                    touchstartX = event.touches[0].clientX;
                }, false);
                cardListContainer.addEventListener("touchend", function(event) {
                    touchendX = event.changedTouches[0].clientX;
                    Carousel.handleGesture(touchendX, touchstartX);
                }, false);
            }
        },
        {
            key: "handleGesture",
            value: function handleGesture(touchendX, touchstartX) {
                if (touchendX < touchstartX) // Swipe left
                Carousel.onRightArrowClick();
                if (touchendX > touchstartX) // Swipe right
                Carousel.onLeftArrowClick();
            }
        },
        {
            key: "render3D",
            value: function render3D() {
                var OFFSET = -50;
                var ROTATION = 40;
                var BASE_ZINDEX = 10;
                var opacity = [
                    1,
                    .7,
                    .3
                ];
                var scale = [
                    1,
                    .9,
                    .75
                ];
                var elts = document.querySelectorAll(".app-emi-carousel-card");
                var position = document.querySelector($adcbf0c91fbb7cf7$export$a002182e51710d39.CARD_LIST).getAttribute("data-emi-carousel-position");
                var isSafari = navigator.userAgent.includes("Safari") && !navigator.userAgent.includes("Chrome");
                for(var i = 0; i < elts.length; i++){
                    elts[i].style.opacity = 0;
                    elts[i].style.display = "inline-block";
                    if (i < position) {
                        elts[i].style.transform = "translateX( " + OFFSET * (position - i + 1) + "%) rotateY(" + ROTATION * (position - i) + "deg) scale(" + (Math.abs(i - position) < 3 ? scale[Math.abs(i - position)] : 0) + ")";
                        elts[i].style.zIndex = BASE_ZINDEX + i;
                        elts[i].style.opacity = Math.abs(i - position) < 3 ? opacity[Math.abs(i - position)] : 0;
                    }
                    if (i == position) {
                        // use translateZ for fixing overlapping bug on Safari
                        elts[i].style.transform = "translateX(-50%) rotateY(0deg)" + (isSafari ? " translateZ(10px)" : "");
                        elts[i].style.zIndex = 100;
                        elts[i].style.opacity = 1;
                    }
                    if (i > position) {
                        elts[i].style.transform = "translateX(" + Math.abs(OFFSET * (i - position - 1)) + "%) rotateY(-" + ROTATION * (i - position) + "deg) scale(" + (Math.abs(i - position) < 3 ? scale[Math.abs(i - position)] : 0) + ")";
                        elts[i].style.zIndex = BASE_ZINDEX + (elts.length - i);
                        elts[i].style.opacity = opacity[i - position];
                    }
                    if (Math.abs(i - position) > 2) elts[i].style.display = "none";
                }
            }
        }
    ]);
    return Carousel;
}();


/* VARIABLES */ // tarot configuration name
var $afb8113a49430423$var$cfg = "tarot-config";
// start the loader
(0, $ae4f30d3c59c8ad6$export$2e2bcd8739ae039).create();
/* For testing purpose only to display the error message */ //if (!window.MaestroInstance2) {
if (!window.MaestroInstance) (0, $ae4f30d3c59c8ad6$export$2e2bcd8739ae039).noMaestroError();
else /* use maestro to load module configuration */ window.MaestroInstance.Store.loadAsync($afb8113a49430423$var$cfg).then(function(e) {
    console.time("render_time");
    console.log("standalone tarot", e);
    if (Object.keys(e).length) $afb8113a49430423$var$mountApp(e);
    //for testing purposes only - add a timeout to get the loader visible on local testing
    /*setTimeout(() => {
            Loader.hide();
        }, 10000);*/ //hide the loader
    (0, $ae4f30d3c59c8ad6$export$2e2bcd8739ae039).hide();
});
function $afb8113a49430423$var$mountApp(e) {
    /* Initialize data for the app - used as default or for local testing*/ var data = {
        deck: (0, $c03bd83856b37a95$export$2e2bcd8739ae039)(e.originalDeck, e.totalCards, true),
        back: {
            source: e.backCardImage
        },
        frame: null,
        title: {
            start: e.openingText,
            end: e.resultText
        },
        config: {
            modalReveal: e.modalReveal,
            module: "tarot",
            amount: e.pickCards,
            duration: 400,
            shape: e.cardDisposition,
            animation: e.animation,
            hideBetweenStep: e.hideBetweenStep,
            css: {
                "overlap-cards": typeof e.overlap === "undefined" ? true : e.overlap,
                "disable-animation": !e.animation,
                "enable-hover": true
            }
        },
        state: {
            selected: [],
            disabled: false
        },
        stop: function stop() {
            this.state.disabled = true;
        },
        start: function start() {
            this.state.disabled = false;
        },
        log: function log() {
            console.log(this.state);
        },
        jitter: function jitter1() {
            this.config.animation = false;
            return (0, $aac1ceba87c6510c$export$2e2bcd8739ae039)(5, 4);
        },
        result: function result() {
            return data.deck[this.state.selected[this.state.selected.length - 1]];
        }
    };
    if (data.config.shape == "pile") data.config.pile = data.jitter();
    if (!(0, $adcbf0c91fbb7cf7$export$2e2bcd8739ae039).isMobile()) (0, $45e5c0a19c79096c$export$2e2bcd8739ae039)(data);
    else (0, $adcbf0c91fbb7cf7$export$2e2bcd8739ae039).render(data);
    console.log("render-data", data);
}

})();
//# sourceMappingURL=index.js.map
